import React, { ReactNode } from 'react'
import NavBar from './NavBar'
import Footer from './Footer'
interface LayOutProps {
   children: ReactNode
}

const Layout = ({ children }: LayOutProps) => {
   return (
      <>
         <NavBar />
         <main>
            <div className='bg-gradiante' />
            {children}
         </main>
         <Footer />
      </>
   )
}

export default Layout